import Badge from '@Components/Badge/Badge';
import NotificationsModal from '@Components/Modals/Notifications/NotificationsModal';
import ModalContext from '@Context/modalContext';
import { ADMIN_ROLES, ASSET_CONTROL_PERMISSIONS, NAV_VALUES } from '@Utils/constants';
import { Button, LogoLoader, Navigation, TopHat, TopHatContext, useUser } from '@kg-internal/pv3-uikit';
import { useContext, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { Outlet, useNavigate } from 'react-router-dom';
import styles from './ProtectedRoutes.module.scss';

const ProtectedRoutes = () => {
  const user = useUser();
  const { isModalOpen } = useContext(ModalContext);
  const block = 'protected-route';
  const navigate = useNavigate();
  const [showNotificationsModal, setShowNotificationsModal] = useState(false);
  const [numberOfAlerts, setNumberOfAlerts] = useState<string>('0');
  const isAdmin = user.hasPermissions(ADMIN_ROLES);
  const isTeamLead = user.hasPermissions(ASSET_CONTROL_PERMISSIONS.LEAD);
  const getNavValues = () => {
    let navValues: string[] = [];

    if (isAdmin) {
      navValues = Object.keys(NAV_VALUES);
    } else {
      navValues = Object.keys(
        Object.fromEntries(
          Object.entries(NAV_VALUES)
            .filter(([, value]) => value.roles === ASSET_CONTROL_PERMISSIONS.ACCESS)
            .map((nav) => {
              if (nav[1].id === 'nav-assets' && !isTeamLead) {
                nav[1].title = 'My Assets';
              }
              return nav;
            }),
        ),
      );
    }

    return navValues.map((key) => {
      const info = NAV_VALUES[key as keyof typeof NAV_VALUES];
      return info;
    });
  };

  const customNavigate = (path: string) => {
    if (path === '.') {
      return;
    } else {
      navigate(path);
    }
  };
  const initialValues = {
    title: 'Asset Control',
    nav: getNavValues(),
  };

  return user ? (
    <TopHatContext navigate={customNavigate} initialValue={initialValues}>
      {isAdmin && (
        <div className={styles[`${block}__button-container`]}>
          <Badge badgeContent={numberOfAlerts} onClick={() => setShowNotificationsModal(true)}>
            <Button type='icon' onClick={() => setShowNotificationsModal(true)}>
              <i className='fa-solid fa-bell' />
            </Button>
          </Badge>
        </div>
      )}
      <div className='grid has-nav'>
        <Navigation currentApp='asset-control' />
        <div className='col-12'>
          <TopHat />
        </div>
      </div>
      {!isModalOpen && <Toaster position='top-right' />}
      <div className='grid-page has-gutters has-nav'>
        <div className='grid'>
          <div className='col-12'>
            <Outlet />
          </div>
        </div>
      </div>
      {isAdmin && (
        <NotificationsModal
          setNumberOfAlerts={setNumberOfAlerts}
          show={showNotificationsModal}
          onClose={() => setShowNotificationsModal(false)}
          setShow={setShowNotificationsModal}
        />
      )}
    </TopHatContext>
  ) : (
    <LogoLoader />
  );
};

export default ProtectedRoutes;
